import React, { useEffect, useLayoutEffect } from "react";
import { useTranslation } from "react-i18next";
import { MobilePlatform } from "@state/stores/types";
import { setTabTitle } from "@utils";
import { useRootAppStore } from "@hooks";

export default function RestrictedPage() {
	const { pageStore } = useRootAppStore<MobilePlatform>();
	const { t } = useTranslation();

	useLayoutEffect(() => {
		pageStore.setMinimalPageHeader();
	}, []);

	useEffect(() => {
		setTabTitle(t("RESTRICTION.RESTRICT_TITLE"));
		//on mount scroll to top
		document.querySelector("html, body")?.scrollTo(0, 0);
	}, []);

	return (
		<>
			<div className="container container--base">
				<div className="card">
					<div className="card__body u-type--center">
						<i className="u-icon u-icon--huge u-icon--empty u-icon--restricted u-icon--animated--bounce-in u-color--sent--danger u-mar--bottom--xsml"></i>
						<div className="u-type--left">
							{t("RESTRICTION.COUNTRY_ACCESS_RESTRICTION_INFO", {
								0: t("RESTRICTION.COMPANY_LABEL"),
							})}
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
